import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import TableComponent from "../common/TableComponent";

import {
  getAllConnectivity,
  AddConnectivity,
  DeleteConnectivity,
  getConnectivityByEdit,
} from "../../api";
import { connectivitySchema } from "../../schema";

const initialValues = {
  connectivity: "",
};

const Connectivity = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [allUserData, setAllUserData] = useState("");
  const [allFilterData, setAllFilterData] = useState("");

  const [show, setShow] = useState(false);
  const [currentElementId, setCurrentElementId] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [blankErr, setBlankErr] = useState(false);

  const tableColumnTitles = [
    {
      name: "Sr.No",
      // field: "Sr.No",
      isSortFilter: false,
      isAction: true,
    },
    {
      name: "Name",
      field: "Name",
      isSortFilter: true,
      isAction: false,
    },
    { name: "Action", isSortFilter: false, isAction: true },
  ];

  const {
    values,
    errors,
    handleSubmit,
    touched,
    setFieldValue,
    // setFieldTouched,
    handleBlur,
  } = useFormik({
    initialValues,
    validationSchema: connectivitySchema(),
    onSubmit: (values, action) => onSubmitHandler(values, action),
  });

  const toast = useRef(null);

  useEffect(() => {
    async function getAllAPI() {
      getConnectivity();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getConnectivity = async () => {
    getAllConnectivity(token)
      .then((res) => {
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
      })
      .catch((err) => {});
  };

  // -------------------------------------------------------------

  const onChangeHandler = (e) => {
    setBlankErr(false);
    setFieldValue("connectivity", e);
  };

  const onSubmitHandler = async (values, action) => {
    if (values.connectivity.trim() === "") {
      setBlankErr(true);
      return;
    }
    if (!blankErr) {
      const reqobj = {
        name_en: values.connectivity.trim(),
      };
      if (isEdit) {
        try {
          const response = await getConnectivityByEdit(
            currentElementId,
            reqobj,
            token
          );
          setIsLoading(true);
          action.resetForm();
          getConnectivity();
          toast.current.show({
            severity: "success",
            summary: `${response?.data?.message}`,
          });
          setTimeout(() => {
            setIsEdit(false);
            setIsLoading(false);
          }, 1000);
        } catch (error) {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: `${error?.response?.data?.message}`,
          });
        }
      } else {
        try {
          const res = await AddConnectivity(reqobj, token);

          setIsLoading(true);
          action.resetForm();
          toast.current.show({
            severity: "success",
            summary: `${res?.data?.message}`,
          });
          getConnectivity();
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        } catch (error) {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: `${error?.response?.data?.message}`,
          });
        }
      }
    }
  };
  // -------------------------------------------------------------
  // edit
  const editUserHandler = (ele) => {
    setFieldValue("connectivity", ele.name_en);
    setIsEdit(true);
    setCurrentElementId(ele.id);
  };
  // -------------------------------------------------------------
  // delete

  const deleteConn = async (id) => {
    setIsLoading(true);
    setShow(false);
    setDeleteId(null);
    DeleteConnectivity(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        getConnectivity();
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "err",
          summary: `${err?.res?.data?.message}`,
        });
      });
  };

  // Filtering
  const updateResponseData = (searchData) => {
    searchData.map((ele) => {
      if (ele.searchField !== "") {
        if (ele?.searchValue !== "") {
          switch (ele.searchField) {
            // case "Sr No":
            //   const dataSrNo = allFilterData.filter((item) =>
            //     item?.index + 1?.includes(ele.searchValue)
            //   );
            //   setAllNewsData(dataSrNo);
            //   break;
            case "Name":
              const dataName = allFilterData.filter((item) =>
                item?.name_en
                  ?.toLowerCase()
                  ?.includes(ele.searchValue?.toLowerCase())
              );
              setAllUserData(dataName);
              break;
            default:
              break;
          }
        } else {
          setAllUserData(allFilterData);
        }
      }
      return "";
    });
  };

  // -------------------------------------------------------------

  const adminTableRequests = (ele, index) => {
    return (
      <>
        <tr key={index} className="table-light">
          <td>{index + 1}</td>
          <td>{ele?.name_en ? ele?.name_en : "-"}</td>
          <td>
            <Link
              // to={{
              //   pathname: "/user-management/profile",
              //   search: `?userId=${ele.id}`,
              // }}
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="#none"
                className="bi bi-pencil-square mx-2 ms-0"
                viewBox="0 0 16 16"
                onClick={() => editUserHandler(ele)}
              >
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path
                  fillRule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            </Link>
            <Link
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
              onClick={() => {
                setDeleteId(ele.id);
                setShow(true);
              }}
            >
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.5 0.25H5.5V1.5H10.5V0.25ZM0.5 2.75V4H1.75V16.5C1.75 17.1904 2.30964 17.75 3 17.75H13C13.6904 17.75 14.25 17.1904 14.25 16.5V4H15.5V2.75H0.5ZM3 16.5V4H13V16.5H3ZM5.5 6.5H6.75V14H5.5V6.5ZM10.5 6.5H9.25V14H10.5V6.5Z"
                  fill="#212121"
                />
              </svg>
            </Link>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />

      {show && (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="logout-modal"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-title text-center">
            Are you sure you want to delete this user?
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center">
            <Button
              variant="secondary"
              className="me-3 yes-btn-cls-add"
              onClick={() => {
                deleteConn(deleteId);
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="no-btn-cls-add"
              onClick={() => {
                setDeleteId(null);
                setShow(false);
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <div className="content-section badges-section upload-user-profile-cls role-management-cls-adding-proper">
        <div className="specialities-tabbing">
          <h6>User Connectivity Details</h6>
          <hr />

          <form onSubmit={handleSubmit} className="">
            <div className="start-here-code">
              <div className="form-all-here-start">
                <div className="row my-4">
                  <div className="col-lg-4">
                    <label className="my-2">
                      Add Connectivity<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="connectivity"
                      id="exampleFormControlInput2"
                      placeholder="Enter user connectivity"
                      value={values.connectivity}
                      onBlur={handleBlur}
                      onChange={(e) => onChangeHandler(e.target.value)}
                    />
                    {errors.connectivity && touched.connectivity ? (
                      <p className="form-error">{errors.connectivity}</p>
                    ) : null}
                    {blankErr && (
                      <p className="form-error">White-space not allowed</p>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <div className="event-details-btn-cls right-side-btn-add edit-btn-only-this-add-for">
                      <button
                        type="submit"
                        className="btn btn-primary edit-btn-cls"
                      >
                        {isEdit ? "Edit" : "Add"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-1">
                <TableComponent
                  tableColumnTitles={tableColumnTitles}
                  tabRequests={allUserData}
                  tableRowRequests={adminTableRequests}
                  updateResponseData={updateResponseData}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Connectivity;
